import { render, staticRenderFns } from "./editdict.vue?vue&type=template&id=521451a8&scoped=true&"
import script from "./editdict.vue?vue&type=script&lang=js&"
export * from "./editdict.vue?vue&type=script&lang=js&"
import style0 from "./editdict.vue?vue&type=style&index=0&id=521451a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521451a8",
  null
  
)

export default component.exports